import { Button, Form, Input, Select, Space } from "antd";
import { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAppSelector } from "../../../../app/store";
import SelectDownIcon from "../../../../assets/icons/SelectDownIcon";
import CardTitle from "../../../../components/common/CardTitle";
import CustomCard from "../../../../components/common/CustomCard";
import SuccessModal from "../../../../components/common/SuccessModal";
import { useCreateBatchMutation } from "../../../../features/portal/batch/batchApi";
import { useGetAllCompanyQuery } from "../../../../features/portal/companyOnboard/companyOnboardApi";
import { useGetAllProductQuery } from "../../../../features/portal/Products/productsApi";
import useError from "../../../../hooks/useError";
import useModal from "../../../../hooks/useModal";
import SidebarLayout from "../../../../layouts/SidebarLayout";

export default function AddNewBatch() {
  const { open, handleOpen, handleClose } = useModal();
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const backLink = "/admin/salary-disbursement/batch";

  const { user } = useAppSelector((state) => state.auth);
  const {
    isError: isAllCompanyError,
    error: allCompanyError,
    data: allCompanyData,
  } = useGetAllCompanyQuery({
    params: {
      company_id: user?.data?.company_id,
      page: 1,
      limit: 1000000000000,
    },
  });
  const {
    isError: isAllProductError,
    error: allProductError,
    data: getAllProduct,
  } = useGetAllProductQuery({});
  const [
    createBatch,
    {
      isError: isCreateBatchError,
      error: createBatchError,
      isLoading: isCreateBatchLoading,
      isSuccess: isCreateBatchSuccess,
    },
  ] = useCreateBatchMutation();
  useError(isAllCompanyError, allCompanyError, "Get all company fail");
  useError(isAllProductError, allProductError, "Get all product fail");
  useError(isCreateBatchError, createBatchError, "Batch create fail");

  const allProduct = getAllProduct?.data?.data;

  const onFinish = (values: any) => {
    const newData = {
      ...values,
      status: "maker",
    };
    createBatch(newData);
  };

  const handleOkay = () => {
    handleClose();
    navigate(`/admin/salary-disbursement/batch`);
  };

  useEffect(() => {
    if (isCreateBatchSuccess) {
      form.resetFields();
      handleOpen({ type: "ADD" });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isCreateBatchSuccess]);

  return (
    <>
      {open?.type === "ADD" && (
        <SuccessModal
          open={open?.open}
          handleClose={handleClose}
          handleOkay={handleOkay}
          data={open?.data}
          title="Successfully batch created"
        />
      )}

      <SidebarLayout title={`Add New Batch`} backLink={backLink}>
        <Form
          className="custom-form"
          layout="vertical"
          requiredMark="optional"
          size="large"
          onFinish={onFinish}
          form={form}
        >
          <CustomCard className=" p-6 pb-0 rounded-b-none">
            <CardTitle>New Batch Info </CardTitle>

            <div className="grid lg:grid-cols-3 md:grid-cols-2 sm:grid-cols-1 gap-x-6 pt-4 mb-6">
              <Form.Item
                label="Batch Name"
                name="batchName"
                rules={[{ required: true, message: "Please enter batch name" }]}
              >
                <Input placeholder="Enter Batch Name" allowClear />
              </Form.Item>

              {/* <Form.Item
                label="Select Status"
                name="status"
                rules={[{ required: true, message: "Please select status" }]}
              >
                <Select
                  placeholder="Select Status"
                  options={[
                    { label: "Maker", value: "maker" },
                    { label: "Checker", value: "checker" },
                    { label: "Approver", value: "approver" },
                  ]}
                  className="w-full"
                  suffixIcon={<SelectDownIcon />}
                  style={{ width: "100%" }}
                  allowClear
                />
              </Form.Item> */}

              <Form.Item
                label="Select Project"
                name="projectId"
                rules={[{ required: true, message: "Please select project" }]}
              >
                <Select
                  placeholder="Select Project"
                  options={
                    allProduct?.map((project: any) => ({
                      label: project?.name,
                      value: project?.id,
                    })) || []
                  }
                  className="w-full"
                  suffixIcon={<SelectDownIcon />}
                  style={{ width: "100%" }}
                  allowClear
                />
              </Form.Item>

              <Form.Item
                label="Select Company"
                name="companyId"
                rules={[{ required: true, message: "Please select company" }]}
              >
                <Select
                  placeholder="Select Company"
                  options={
                    allCompanyData?.data?.companies?.map((company: any) => ({
                      label: company?.company_name,
                      value: company?.id,
                    })) || []
                  }
                  className="w-full"
                  suffixIcon={<SelectDownIcon />}
                  style={{ width: "100%" }}
                  allowClear
                />
              </Form.Item>
            </div>
          </CustomCard>

          {/* sticky bottom-0 */}
          <div className="p-6 rounded-md rounded-t-none bg-white border border-t-0 border-light">
            <Space className="w-full mt-2" size={12}>
              <Link to={backLink}>
                <Button
                  className="normal-dark-button modal-button"
                  size="middle"
                >
                  Cancel
                </Button>
              </Link>
              <Button
                className="modal-button"
                type="primary"
                htmlType="submit"
                size="middle"
                loading={isCreateBatchLoading}
              >
                Save
              </Button>
            </Space>
          </div>
        </Form>
      </SidebarLayout>
    </>
  );
}
